// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__E6aEl","class":"styles_class__rQZ3B","state":"styles_state__dXl0L","property":"styles_property__me8xK","bold":"styles_bold__Lfb2S"};